// extracted by mini-css-extract-plugin
export default {"device-management-container":"DeviceManagement_device-management-container__LPVk1","device-management-header":"DeviceManagement_device-management-header__C8E5t"};